<!--
    描述：首页项目列表--具体内容
    时间：2020-03-16
    Created by ws
-->
<template>
    <div class="w-table-layout w-table-page">
        <transition name="fade"
                    mode="out-in">
            <!-- 卡片版 -->
            <div class="card-wrap w-table-content"
                 v-if="curType === 1"
                 key="card">
                <div class="card-container"
                     v-loading="tableObj.loading">
                    <div v-for="(item, index) in tableObj.tableData"
                         :key="'card' + index"
                         class="card-item">
                        <div class="card-header">
                            <div class="title text-overflow rowName"
                                 @click="goPage(item)">{{ item.pname }}
                            </div>
                            <div class="btnTools">
                                <el-dropdown @command="doClick(item, $event)">
									<span class="el-dropdown-link">
										操作<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item icon="el-icon-search" command="view">查看</el-dropdown-item>
                                        <el-dropdown-item icon="el-icon-edit" command="edit">编辑</el-dropdown-item>
                                        <el-dropdown-item icon="el-icon-delete" command="delete">删除</el-dropdown-item>
                                        <el-dropdown-item icon="el-icon-refresh" command="init">初始化</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="left-info">
                                <p class="info-text text-overflow">
                                    <span>创建人：</span>
                                    <span>{{ item.createUser }}</span>
                                </p>
                                <p class="info-text text-overflow">
                                    <span>创建日期：</span>
                                    <span>{{ item.createDate }}</span>
                                </p>
                                <p class="info-text text-overflow">
                                    <span>最后更新日期：</span>
                                    <span>{{ item.updateDate }}</span>
                                </p>
                            </div>
                            <div class="right-pic">
                                <img src="@/assets/images/avatar.png"
                                     alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 列表 -->
            <div class="list-wrap w-table-content"
                 v-else
                 ref="tableContent"
                 key="list">
                <el-table :data="tableObj.tableData"
                          :height="tableObj.tableH"
                          highlight-current-row
                          v-loading="tableObj.loading"
                          stripe>
                    <el-table-column type="index"
                                     label="序号"
                                     align="center"
                                     width="50">
                    </el-table-column>
                    <el-table-column label="操作"
                                     align="center"
                                     width="120">
                        <template slot-scope="scope">
                            <el-button size="mini"
                                       icon="el-icon-search"
                                       type="text"
                                       @click="doClick(scope.row, 'view')"
                                       title="查看"></el-button>
                            <el-button size="mini"
                                       icon="el-icon-edit"
                                       title="编辑"
                                       @click="doClick(scope.row, 'edit')"
                                       type="text"></el-button>
                            <el-button size="mini"
                                       type="text"
                                       icon="el-icon-delete"
                                       @click="doClick(scope.row, 'delete')"
                                       title="删除"></el-button>
                            <el-button size="mini"
                                       type="text"
                                       icon="el-icon-refresh"
                                       @click="doClick(scope.row, 'init')"
                                       title="初始化"></el-button>
                        </template>
                    </el-table-column>
                    <el-table-column prop="pname"
                                     label="项目名称"
                                     show-overflow-tooltip
                                     min-width="180">
                        <template slot-scope="scope">
                            <a class="rowName"
                               @click="goPage(scope.row)">{{ scope.row.pname }}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="client"
                                     label="委托单位"
                                     min-width="180">
                    </el-table-column>
                    <el-table-column prop="userCompany"
                                     label="使用单位"
                                     min-width="180">
                    </el-table-column>
                    <el-table-column prop="ptype"
                                     label="项目类型"
                                     width="150">
                    </el-table-column>
                    <el-table-column prop="mname"
                                     label="项目负责人"
                                     width="110">
                    </el-table-column>
                    <el-table-column prop="pmName"
                                     label="产品经理"
                                     width="110">
                    </el-table-column>
                    <el-table-column prop="dmName"
                                     label="开发经理"
                                     width="110">
                    </el-table-column>
                    <el-table-column prop="tmName"
                                     label="测试经理"
                                     align="center"
                                     width="130">
                    </el-table-column>
                    <el-table-column prop="startDate"
                                     label="启动日期"
                                     align="center"
                                     width="110">
                    </el-table-column>
                    <el-table-column prop="pstatusName"
                                     label="项目状态"
                                     align="center"
                                     width="110">
                    </el-table-column>
                </el-table>
            </div>
        </transition>

        <!-- 底部分页 -->
        <div class="w-table-footer">
            <el-pagination @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="tableObj.currentPage"
                           :page-sizes="tableObj.pageList"
                           :page-size="tableObj.pageSize"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="tableObj.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex'
    import {
        getProject,
        searchProject,
        deleteProject,
        initProject
    } from '@/api/modules/dataProject.js'
    // import * as dataProject from '@/api/modules/dataProject.js'
    export default {
        props: {
            // 当前类型 1 卡片， 2 列表
            curType: {
                type: Number,
                default: 1
            },
            // 搜索参数
            searchObj: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data() {
            return {
                projectList: [],
                tableObj: {
                    loading: false,
                    pageSize: 10,
                    currentPage: 1,
                    total: 0,
                    tableH: 0,
                    tableData: [],
                    pageList: [10, 20, 50, 100] // 显示条数数组
                },
                projectForm: {},
                initProjectInfo: {
                    id: '',
                    db_username: 'yany',
                    db_pwd: 'ac6e8f437fe1effb'
                },
                deleteProjectList: {
                    idList: []
                }
            }
        },
        methods: {
            ...mapActions('menu', ['setMenu', 'setTabsList', 'setActiveTab']),
            ...mapMutations('projectList', ['SET_PROJECT_DATA']),
            // 获取项目列表
            getProjectList() {
                this.tableObj.loading = true

                getProject(this.searchObj)
                    .then(res => {
                        this.tableObj.loading = false
                        this.tableObj.tableData = res.data.records
                        this.tableObj.total = parseInt(res.data.total)
                    })
                    .catch(err => {
                        this.tableObj.loading = true
                    })
            },
            // 搜索查询
            doSearch() {
                this.tableObj.loading = true;
                this.searchObj.current = this.tableObj.currentPage;
                this.searchObj.size = this.tableObj.pageSize;
                searchProject(this.searchObj)
                    .then(res => {
                        this.tableObj.loading = false
                        this.tableObj.tableData = res.data.records
                        this.tableObj.total = parseInt(res.data.total)
                    })
                    .catch(err => {
                        this.tableObj.loading = false
                    })
            },

            // 行点击操作
            doClick(row, type) {
                // 初始化
                if (type === 'init') {
                    this.$confirm('确认要初始化当前项目吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.initProjectInfo.id = row.id;
                        initProject(this.initProjectInfo).then(res => {
                            this.$message.success(res.msg);
                        })
                    }).catch(() => {})
                    return;
                }
                // 删除
                if (type === 'delete') {
                    this.$confirm('确认要删除当前项目吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                        .then(() => {
                            this.deleteProjectList.idList.push(row.id);
                            deleteProject(this.deleteProjectList).then(res => {
                                // console.log(res)
                                this.$message.success('删除成功！')
                                this.doSearch()
                            })
                        })
                        .catch(() => {
                        })
                } else {
                    // 查看 或 编辑
                    this.$emit('rowClick', row, type)
                }
            },

            // 点击跳转页面
            goPage(obj) {
                // 项目信息加入store
                this.SET_PROJECT_DATA(obj)

                // 更新左侧菜单
                let _project = this.routeList.find(x => x.path === '/project')

                if (_project) {
                    this.setMenu('/project')

                    // 设置上方 tabs
                    let _exist = this.tabsList.find(x => x.name === obj.id)
                    if (_exist) {
                        this.setActiveTab(obj.id)
                    } else {
                        let _arr = JSON.parse(JSON.stringify(this.tabsList))
                        _arr.push({
                            name: obj.id,
                            path: '/project',
                            title: obj.pname
                        })
                        this.setTabsList(_arr)
                        this.setActiveTab(obj.id)
                    }

                    // 跳转路由
                    this.$router.push({
                        path: '/project'
                    })
                }
            },

            // 切换显示条数
            handleSizeChange(val) {
                this.tableObj.pageSize = val
                this.getProjectList()
            },

            // 切换当前页码
            handleCurrentChange(cur) {
                this.tableObj.currentPage = cur
                this.getProjectList()
            }
        },
        created() {
            // this.getProjectList()
        },
        computed: {
            ...mapState('menu', {
                tabsList: state => state.tabsList
            }),
            // 路由列表
            routeList() {
                return this.$router.options.routes
            }
        },
        watch: {
            curType() {
                setTimeout(() => {
                    if (this.$refs.tableContent) {
                        this.tableObj.tableH = this.$refs.tableContent.offsetHeight
                    }
                }, 400)
            }
        }
    }
</script>

<style scoped lang="less">
    .card-wrap {
        height: 100%;
        overflow-y: auto;
    }

    .card-container {
        display: flex;
        flex-wrap: wrap;
        // height: 100%;

        .card-item {
            width: 400px;
            height: 200px;
            margin: 10px;
            display: flex;
            flex-direction: column;
            box-shadow: 2px 2px 3px 2px #ccc;
        }

        .card-header {
            height: 40px;
            line-height: 40px;
            display: flex;
            justify-content: space-between;
            padding: 0 15px;

            .title {
                font-size: 15px;
                font-weight: 700;
                cursor: pointer;
            }

            .btnTools {
                width: 80px;
                flex-shrink: 0;
                text-align: right;
            }
        }

        .card-content {
            flex: 1;
            overflow: hidden;
            display: flex;
            justify-content: space-between;

            .left-info {
                flex: 1;
                width: 0;
                padding: 15px;
                font-size: 14px;
                color: #666;
            }

            .info-text {
                height: 30px;
                line-height: 30px;
            }

            .right-pic {
                width: 150px;
                height: 100%;
                overflow: hidden;
                padding: 15px;
            }

            img {
                width: 100%;
                height: 100%;
                background-size: cover;
            }
        }
    }

    .list-wrap {
        .rowName {
            color: #409eff;
            cursor: pointer;
        }
    }
</style>
